import Vue from 'vue'
import App from './App.vue'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import '@fortawesome/fontawesome-pro/css/all.css'

Vue.use(VueMaterial)

import VueResource from 'vue-resource';
Vue.use(VueResource);
// Vue.http.options.emulateJSON = true;

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

Vue.config.productionTip = false

import {setupI18n} from './locale';


const getCurrentQueryParams = () => {
  const [url, queryStr] = window.location.href.split('?');
  if (queryStr) {
    return queryStr.split('&')
    .map(_ => {
      const [paramName, value] = _.split('=');
      return { paramName, value}
    })
    .reduce((p, c) => { p[c.paramName] = c.value; return p;}, {});
  }
  return {};
}

export function setup(config, versions) {

  if (config.sentryDsn) {
    Sentry.init({dsn: config.sentryDsn});
  }

  const customLocales = config.i18n && config.i18n.messages;
  const i18n = setupI18n(customLocales);

  new Vue({
    i18n,
    render: h => h(App),
    data() {
      return {
        config,
        versions,
        events: config.events ?? {},
      }
    },
    created() {

      const i18n = Vue.prototype.$t;
      const that = this;
      Vue.prototype.$t = function (label) {
        if (typeof label === 'object') {
          return label[that.locale] || label[Object.keys(label).shift()] || label;
        }
        return i18n.apply(this, arguments);
      }

      const queryParams = getCurrentQueryParams();
      this.$i18n.locale = queryParams?.locale || config.defaultLanguage || navigator.language.split('-').shift();
      document.title = config.documentTitle;
    },
    computed: {
      globalComponent() {
        return this.$children[0]
      },
      locale() {
        return this.$i18n.locale;
      },
      lang() {
        return ((this.$i18n.messages[this.$i18n.locale] || {}).Lang || {}).iso || '';
      }
    },

  }).$mount('#app')
}
